import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const paymentService = {
    getAllPayments,
    updatePaymentStatus,
    getPayment,
    updatePayment,
    createPayment,
};

const MODULE = {
    PAYMENT: 'rnd-product-payments',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'payment') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllPayments(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            product: filter.product,
            type: filter.type,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return await apiHelper(API_URL).get(`/${MODULE.PAYMENT}`, requestOptions)
}


export function updatePaymentStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.PAYMENT}/${data.id}`, requestOptions)
}

export function getPayment(id) {
    return apiHelper(API_URL).get(`/${MODULE.PAYMENT}/${id}`)
}

export function updatePayment(data) {
    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        type: data.type,
        date: data.date,
    }
    return apiHelper(API_URL).put(`/${MODULE.PAYMENT}/${data.id}`, requestOptions)
}

export function createPayment(data) {
    const requestOptions = {
        product_uuid: data.productID,
        remark: data.remark,
        type: data.type,
        date: data.date,
    }

    return apiHelper(API_URL).post(`/${MODULE.PAYMENT}`, requestOptions)
}